const routes = [
    {
        path: '/cscr',
        name: 'Cscr',
        meta: {
            layout: 'basic'
        },
        component: () => import(/* webpackChunkName: "main" */ '@/views/cscr/cscr-main.vue'),
        children: [
            {
                path: '/cscr/nttm',
                name: 'Nttm',
                meta: {
                    layout: 'basic'
                },
                component: () => import(/* webpackChunkName: "main" */ '@/views/cscr/nttm.vue'),
            },
            {
                path: '/cscr/faq',
                name: 'Faq',
                meta: {
                    layout: 'basic'
                },
                component: () => import(/* webpackChunkName: "main" */ '@/views/cscr/faq.vue'),
            },
            {
                path: '/cscr/inqry',
                name: 'Inqry',
                meta: {
                    layout: 'basic'
                },
                component: () => import(/* webpackChunkName: "main" */ '@/views/cscr/inqry.vue'),
            },
            {
                path: '/cscr/rmte-sprt',
                name: 'RmteSprt',
                meta: {
                    layout: 'basic'
                },
                component: () => import(/* webpackChunkName: "main" */ '@/views/cscr/rmte-sprt.vue'),
            },
        ]
    },
]

export default routes;